<template>
  <div class="message-notice-container">    
    <a-badge :count="unreadCount" :numberStyle="{ backgroundColor: '#f5222d', boxShadow: '0 0 0 1px #fff' }">
      <a-button 
        type="default" 
        shape="circle" 
        size="large"
        @click="handleVisibleChange"
        class="notice-trigger-btn"
      >
        <a-icon type="bell" />
      </a-button>
    </a-badge>

    <!-- 消息弹窗 -->
    <a-popover
      v-model="visible"
      trigger="click"
      placement="bottomRight"
      overlayClassName="custom-message-popover"
      :getPopupContainer="trigger => trigger.parentElement"
      :overlayStyle="{ width: '360px' }"
    >
      <template slot="content">
        <div class="message-popover-content">
          <!-- 头部 -->
          <!-- <div class="popover-header">
            <span class="header-title">消息提醒</span>
            <a-icon 
              type="sync" 
              :spin="loading" 
              class="refresh-icon" 
              @click="handleRefresh" 
              title="刷新"
            />
            <a @click="goToMessageList" class="view-all-link">查看全部</a>
          </div> -->
          <div class="panel-header">
            <h3>消息提醒</h3>
            <div class="header-actions">
              <a-icon type="sync" :spin="loading"  @click="handleRefresh" style="margin-right: 12px; cursor: pointer;" title="刷新" />
              <a @click="goToMessageList" class="view-all-link">查看全部</a>
            </div>
          </div>

          <!-- 消息列表 -->
          <div class="message-list-wrapper">
            <a-list
              :data-source="messages"
              :loading="loading"
              class="message-list"
            >              
              <a-list-item slot="renderItem" slot-scope="item" class="message-item" @click="handleView(item)">
                <div class="message-row">
                <div class="item-category" v-if="item.type">
                  <a-tag color="#f0f5ff" style="border-color: #d6e4ff; color: #2f54eb;">
                    <a-icon type="file-text" /> {{ item.type }}
                  </a-tag>
                  <!-- 未读标记 (右侧小蓝点) -->
                  <!-- <a-badge v-if="!item.read" count="" dot :numberStyle="{ backgroundColor: '#1890ff' }" /> -->
                </div>

                <!-- 消息内容 -->
                <div class="item-content">
                  <div class="item-subject">
                    {{ item.title }}
                  </div>
                  <div class="item-meta">
                    <!-- <span class="item-sender">{{ item.sender }}</span> -->
                    <span class="item-time">{{ item.createTime }}</span>
                  </div>
                </div>

                <!-- 操作区 (标记已读) -->                
                <div class="item-action">
                  <a-tooltip v-if="!item.read" title="标记为已读">
                    <a-icon type="check-circle" theme="filled" class="read-icon" @click="markAsRead(item.id)" />
                  </a-tooltip>
                  <span v-else class="action-placeholder"></span>
                </div>
                </div>
              </a-list-item>
            </a-list>            
          </div>

          <!-- 底部操作栏 -->
          <!-- <div class="popover-footer" v-if="displayList.length > 0">
            <a-button type="link" block @click="markAllAsRead" :disabled="unreadCount === 0">
              全部已读
            </a-button>
          </div> -->
        </div>
      </template>      
      <!-- <div></div> -->
    </a-popover>
    <mes-modal ref="modalForm" @loadData="loadMessages"></mes-modal>
  </div>
</template>

<script>
import { Badge, Button, Icon, Popover, List, Tag, Empty, Tooltip } from 'ant-design-vue';
// import simpleImage from 'ant-design-vue/lib/result/emptySimple.png';
import { getAction, postAction } from '@api/manage'
import MesModal from '@/views/project/message/modules/MesModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

export default {
  name: 'MessageNotice',
  mixins:[JeecgListMixin],
  components: {
    ABadge: Badge,
    AButton: Button,
    AIcon: Icon,
    APopover: Popover,
    AList: List,
    AListItem: List.Item,
    ATag: Tag,
    AEmpty: Empty,
    ATooltip: Tooltip,
    MesModal
  },
  props: {
  },
  data() {
    return {
      loading: false,
      visible: false,
      simpleImage:'',
      messages:[],
    };
  },
  watch: {
    // 监听外部传入的 messages 变化，同步到内部
    messages: {
      handler(newVal) {
        
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    // 计算未读消息数量
    unreadCount() {
      return this.messages.length;
    },    
  },
  created(){
    this.loadMessages();
  },
  methods: {
    goToMessageList() {
      this.$router.push({ path: '/project/message/list' })
    },
    loadMessages() {
      this.loading = true;
      getAction('/project/projectNotice/not_read/list', {}).then((res) => {
          if (res.success) {
            this.messages = res.result
          }else{
            this.$message.warning(res.message)
          }
        }).finally(() => {
          this.loading = false;
        });
    },
    handleVisibleChange(vis) {
      console.log('handleVisibleChange:', vis);
      this.visible = true;
    },
    
    // 标记单条为已读
    markAsRead(id) {
      const that = this
      that.loading = true;
      postAction('/project/projectNotice/readById', {"id":id}).then((res) => {
              if (res.success) {
                this.loadMessages();
                that.$message.success(res.message)
              } else {
                that.$message.warning(res.message)
              }
            }).finally(() => {
              that.loading = false;
            })
    },

    // 全部标记为已读
    markAllAsRead() {
      
    },

    // 刷新按钮
    handleRefresh() {
      this.loadMessages();
    }
  }
};
</script>

<style lang="less" scoped>
.message-notice-container {
  display: inline-block;
  
  .notice-trigger-btn {
    font-size: 18px;
    width: 40px;
    height: 40px;
    border: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s;
    
    &:hover {
      color: #1890ff;
      background-color: #e6f7ff;
      transform: translateY(-1px);
    }
  }
}

// 自定义 Popover 样式
.custom-message-popover {
  /deep/ .ant-popover-inner-content {
    padding: 0;
  }
}

.message-popover-content {
  display: flex;
  flex-direction: column;
  max-height: 500px;

  .popover-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #f0f0f0;
    background-color: #fafafa;

    .header-title {
      font-weight: 600;
      font-size: 16px;
      color: #333;
    }

    .refresh-icon {
      margin-right: 12px;
      font-size: 16px;
      color: #666;
      cursor: pointer;
      transition: color 0.3s;
      
      &:hover {
        color: #1890ff;
      }
    }
  }

  .panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .view-all-link {
    font-size: 14px;
    color: #1890ff;
    text-decoration: none;
    cursor: pointer;
  }

  .view-all-link:hover {
    text-decoration: underline;
  }

  .message-list-wrapper {
    flex: 1;
    overflow-y: auto;
    min-height: 200px;
    max-height: 400px;

    // 自定义滚动条
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background: #ddd;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-track {
      background: #f5f5f5;
    }

    .message-list {
      padding: 0;

      .message-item {
        padding: 12px 16px !important;
        border-bottom: 1px solid #f5f5f5;
        transition: background 0.3s;
        cursor: pointer;

        &:hover {
          background-color: #f5f5f5;
        }

        .message-row {
          display: flex;
          align-items: flex-start; /* 顶部对齐 */
          gap: 16px; /* 各部分间距 */
        }

        .item-category {
          flex-shrink: 0; /* 不让分类标签压缩 */
          display: flex;
          align-items: center;
          gap: 8px;

          .ant-tag {
            margin: 0;
            font-size: 12px;
            padding: 2px 8px;
          }
        }

        .item-content {
          flex: 1; /* 占据剩余空间，自然靠左 */
          min-width: 0; /* 防止溢出 */

          .item-subject {
            font-size: 14px;
            font-weight: 500;
            color: #262626;
            margin-bottom: 4px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .item-id {
              font-size: 12px;
              color: #8c8c8c;
              font-weight: normal;
              margin-left: 12px;
            }
          }

          .item-meta {
            font-size: 12px;
            color: #8c8c8c;
            display: flex;
            gap: 16px;

            .item-sender {
              color: #595959;
            }
          }
        }

        .item-action {
          flex-shrink: 0;
          min-width: 24px;
          display: flex;
          justify-content: center;
          align-items: center;

          .read-icon {
            font-size: 20px;
            color: #52c41a;
            cursor: pointer;
            transition: transform 0.2s;

            &:hover {
              transform: scale(1.1);
            }
          }

          .action-placeholder {
            display: inline-block;
            width: 20px;
            height: 20px;
            visibility: hidden;
          }
        }        
        
      }
    }

    .empty-state {
      padding: 40px 0;
      text-align: center;
    }
  }

  .popover-footer {
    padding: 8px 0;
    border-top: 1px solid #f0f0f0;
    background-color: #fafafa;
    text-align: center;

    /deep/ .ant-btn {
      color: #666;
      font-size: 14px;
      
      &[disabled] {
        color: #ccc;
      }
    }
  }
}
</style>